import React, { useState } from "react";
import "../App.css";
import { Link, useNavigate } from "react-router-dom";

export default function LandingPage() {
  const router = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <div className="landingPageContainer">
      <nav>
        <div className="navHeader">
          <img src="/logo.png" alt="QuickMeet Logo" />
        </div>

        {/* Hamburger Menu Toggle */}
        <div className="menuToggle" style={{}} onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* Navigation Links */}
        <div className={`navlist ${menuOpen ? "active" : ""}`}>
          <p
            onClick={() => {
              router("/aljk23");
              setMenuOpen(false);
            }}
          >
            Join as Guest
          </p>
          <p
            onClick={() => {
              router("/auth");
              setMenuOpen(false);
            }}
          >
            Register
          </p>
          <div
            onClick={() => {
              router("/auth");
              setMenuOpen(false);
            }}
            role="button"
          >
            <p>Login</p>
          </div>
        </div>
      </nav>

      <div className="landingMainContainer">
        <div>
          <h1>
            <span style={{ color: "#D97500" }}>Connect</span> with your loved
            Ones
          </h1>
          <p>
            Cover a distance by{" "}
            <span style={{ color: "#D97500" }}>QuickMeet</span>
          </p>
          <div role="button">
            <Link to={"/auth"}>Get Started</Link>
          </div>
        </div>
        <div>
          <img src="/mobile.png" alt="QuickMeet on Mobile" />
        </div>
      </div>
    </div>
  );
}
